{
  "replaceMessage": "Presuňte súbor, ktorý chcete nahradiť"
}
